<template>
  <form action="">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">
          {{ $t("privateMsg") }}
        </p>
      </header>
      <section class="modal-card-body">
        <div class="mb-2">
          {{ $t("privateMsgTo", { name: participant.name }) }}
        </div>
        <div class="pm-container">
          <b-input
            v-model="messageInput"
            style="flex-grow: 1"
            class="mr-1"
            type="text"
            :loading="isSending"
            @keydown.enter.prevent.native="sendMessage"
          />
          <UploadFile @fileUploaded="sendUploadedFile">
            <a class="button mr-1">
              <b-icon icon="upload" />
            </a>
          </UploadFile>
          <b-button type="is-primary" icon-left="send" :loading="isSending" @click="sendMessage" />
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">
          {{ $t("close") }}
        </button>
      </footer>
    </div>
  </form>
</template>

<script>
import { FieldValue } from "@/firebase";
import UploadFile from "./UploadFile";

export default {
  name: "PayBillModal",
  components: {
    UploadFile,
  },
  props: {
    participant: {
      type: Object,
      default() {
        return {};
      },
    },
    messagesCollection: {
      type: Object,
      default() {
        return {};
      },
    },
    cipher: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isSending: false,
      messageInput: "",
    };
  },
  methods: {
    sendMessage(e) {
      try {
        e.preventDefault();
      } catch (err) {
        console.log(err);
      }
      this.isSending = true;

      this.messagesCollection
        .add({
          userId: this.$store.getters.getCurrentUser.uid,
          userName: this.$store.getters["mediasoup/getDisplayName"],
          channel: [this.participant.id, this.$store.getters.getCurrentUser.uid],
          body: this.cipher.encrypt((this.messageInput.length == 0 ? " " : "") + this.messageInput),
          timestamp: FieldValue.serverTimestamp(),
        })
        .then(() => {
          this.messageInput = "";
        })
        .finally(() => {
          this.isSending = false;
          this.$parent.close();
        });
    },
    sendUploadedFile(file) {
      console.log(file);
      this.messageInput = `//file ${JSON.stringify(file)}`;
      this.sendMessage();
    },
  },
};
</script>

<style scoped>
.pm-container {
  min-width: 450px;
  display: flex;
}
</style>
